<div id="diagnosis-prediction-page" class="diagnosis-prediction-page container" *ngIf="data">
    <div class="diagnosis-prediction-pag--back_btn">
        <button class="btn btn-link btn-icon btn-icon--left btn-back btn--secondary" (click)="back()">
            {{ 'back' | translate }}
        </button>
    </div>

    <div tabindex="0" class="mt-2">
        <div class="diagnosis-prediction-page--image">
            <img src="{{data.image.filename}}">
        </div>

        <div class="diagnosis-prediction-page--header">
            {{data.title}}
        </div>
        
        <div class="diagnosis-prediction-page--body">
            <div [innerHTML]="data.article_body | storyblokRichtext"></div>
        </div>
    </div>

    <div class="diagnosis-prediction-page--package" *ngIf="packageData">
        <me-package [bexioData]="packageData" [type]="articleType"
                    [header]="'Our recommendation' | translate"></me-package>
    </div>

    <div class="diagnosis-prediction-page--btn">
        <button class="btn btn-link btn-icon btn-icon--left btn--secondary " (click)="toTop()">
            <i class="far fa-arrow-up"></i>
            {{ 'Back to top' | translate }}
        </button>
    </div>
</div>